document.addEventListener('DOMContentLoaded', function () {
  const cards = document.querySelectorAll('.f-column.variable-products[data-variant-id]');
  
  cards.forEach(function (card) {
    const variantId = card.dataset.variantId;
    if (!variantId) return;

    fetch(`/variants/${variantId}.js`)
      .then(res => res.json())
      .then(variant => {
        if (variant.available === false) {
          // Badge rupture
          const imageWrapper = card.querySelector('.product-card__image-wrapper');
          if (imageWrapper) {
            imageWrapper.classList.add('product-card__image-wrapper--soldout');
            const badge = document.createElement('div');
            badge.className = 'product-card__badge';
            badge.innerHTML = '<span class="f-badge f-badge--soldout">Rupture de stock</span>';
            imageWrapper.appendChild(badge);
          }
        }
      });
  });
});
// ===== FICHE PRODUIT : badge rupture sur l'image =====
function updateProductPageBadge(variantId) {
  const mediaWrapper = document.querySelector('.product__media-wrapper');
  if (!mediaWrapper) return;

  // Supprimer le badge existant s'il y en a un
  const existingBadge = mediaWrapper.querySelector('.sold-out-badge-product');
  if (existingBadge) existingBadge.remove();
  mediaWrapper.classList.remove('product-media--soldout');

  if (!variantId) return;

  fetch(`/variants/${variantId}.js`)
    .then(res => res.json())
    .then(variant => {
      if (variant.available === false) {
        mediaWrapper.classList.add('product-media--soldout');
        const badge = document.createElement('div');
        badge.className = 'sold-out-badge-product product-card__badge';
        badge.innerHTML = '<span class="f-badge f-badge--soldout">Rupture de stock</span>';
        badge.style.cssText = 'position:absolute;top:12px;left:12px;z-index:10;';
        mediaWrapper.style.position = 'relative';
        mediaWrapper.appendChild(badge);
      }
    });
}

// Au chargement de la page
if (document.querySelector('.product__media-wrapper')) {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  if (variantId) updateProductPageBadge(variantId);

  // Quand le variant change
  document.addEventListener('variant:change', function(e) {
    if (e.detail && e.detail.variant) {
      updateProductPageBadge(e.detail.variant.id);
    }
  });

  // Fallback : écouter les changements d'URL
  window.addEventListener('popstate', function() {
    const params = new URLSearchParams(window.location.search);
    const vid = params.get('variant');
    if (vid) updateProductPageBadge(vid);
  });
}